import React from 'react';
import { Toolbar, Grid, Stack, MenuItem, Button, IconButton, Paper, InputAdornment } from "@mui/material";
import ReplayIcon from '@mui/icons-material/Replay';
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from 'formik';
import get from "lodash/get";
import map from "lodash/map";
import AutoComplete from "../../../components/form/AutoComplete";

const ToolbarComponent = ({ setFilter, __, reload, isLoading }) => {

    const onSubmit = (values) => {
        let Filters = {
            docId: 0,
            maeId: "",
            screen: String(get(values, "value", ""))
          };
        setFilter(Filters)
    }

    const screen = useSelector(state => state.config.log.optionScreen);

    const screenOptions = map(screen?.data.data, ({ screen }) => ({
      value: screen,
      label: screen,
    }));
  

    const formik = useFormik({
        initialValues: {
            screen: ""
        },
        onSubmit,
    });

    const onClear = (field) => async () => {
        await formik.setFieldValue(field, "")
        formik.submitForm()
    }

    return (
        <Toolbar component={Paper} className='p-2 mb-4' sx={{ borderBottomWidth: "1px", borderBottomColor: "text.sslite", borderBottomStyle: "solid", position: "sticky", top: 0, zIndex: 100 }}>
            <Stack component="form" onSubmit={get(formik, "handleSubmit")} direction={{ sx: "column", xl: "row" }} alignItems={{ sx: "flex-start", xl: "center" }} justifyContent={{ sx: "center", xl: "space-between" }} spacing={{ sx: 1, xl: 1 }} className='w-full'>
                <Grid container spacing={1} justifyContent={{ sx: "flex-end", md: "flex-end" }}>
                    <Grid item xs={6} md={3} lg={2} xl={1}>
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <IconButton title={__(`toolbar.reload`)} onClick={reload}><ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} /></IconButton>
                        </Stack>
                    </Grid>
                </Grid>
            </Stack>
        </Toolbar>
    )
}

export default ToolbarComponent